(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table-v1"] && !Shopify.designMode) return;
  try {
    
  
  (() => {
    const wrapper = document.getElementById('vetanica-wrapper');
    const track = document.querySelector('.vetanica-indicator-track');
    const thumb = document.getElementById('vetanica-indicator-thumb');
    if (!wrapper || !track || !thumb) return;

    let maxScroll = 1;
    let travelPx = 0;
    let rafId = 0;
    let stopTimer = 0;

    function stickyWidth() {
      const label = wrapper.querySelector('.col-label');
      const vetanica = wrapper.querySelector('.col-vetanica');
      return (label?.offsetWidth || 0) + (vetanica?.offsetWidth || 0);
    }

    // Only called on load + resize (not during scroll)
    function init() {
      const sw = stickyWidth();
      const realScrollWidth = Math.max(1, wrapper.scrollWidth - sw);
      const realClientWidth = Math.max(1, wrapper.clientWidth - sw);
      maxScroll = Math.max(1, realScrollWidth - realClientWidth);

      const visibleRatio = realClientWidth / realScrollWidth;
      const minThumbRatio = 0.18;
      const thumbRatio = Math.max(minThumbRatio, Math.min(1, visibleRatio));

      const trackW = track.clientWidth;
      const thumbW = Math.round(trackW * thumbRatio);
      thumb.style.width = thumbW + 'px';
      travelPx = Math.max(0, trackW - thumbW);

      paint();
    }

    // Only does: read scrollLeft + set transform
    function paint() {
      const p = Math.min(1, Math.max(0, wrapper.scrollLeft / maxScroll));
      const x = (travelPx * p) | 0; // fast floor
      thumb.style.transform = `translate3d(${x}px,0,0)`;
    }

    function startTicker() {
      if (rafId) return;
      const tick = () => {
        paint();
        rafId = requestAnimationFrame(tick);
      };
      rafId = requestAnimationFrame(tick);
    }

    function stopTickerSoon() {
      clearTimeout(stopTimer);
      stopTimer = setTimeout(() => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = 0;
        paint(); // final settle
      }, 120);
    }

    // Scroll events just start/extend the ticker, no heavy work
    wrapper.addEventListener(
      'scroll',
      () => {
        startTicker();
        stopTickerSoon();
      },
      { passive: true }
    );

    // Touch can start momentum scrolling without many scroll events initially
    wrapper.addEventListener('touchstart', startTicker, { passive: true });
    wrapper.addEventListener('touchend', stopTickerSoon, { passive: true });

    window.addEventListener('resize', () => {
      init();
      startTicker();
      stopTickerSoon();
    });

    // GPU hint
    thumb.style.willChange = 'transform';
    thumb.style.transform = 'translate3d(0,0,0)';

    init();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eam-lp-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const header = document.getElementById('eam-lp-header');
    const scrollThreshold = 100;

    function handleScroll() {
      if (window.scrollY >= scrollThreshold) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', handleScroll);
    
    // Check initial scroll position
    handleScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordions"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
        const accordionParent = header.parentElement;
        const content = header.nextElementSibling;
        const contentInner = content.querySelector('.accordion-content-inner');
        accordionParent.classList.toggle('active');
        if (accordionParent.classList.contains('active')) {
            content.style.height = contentInner.scrollHeight + 20 + 'px';
        } else {
            content.style.height = 0;
        }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
